import { render, staticRenderFns } from "./AngsuranKelompok.vue?vue&type=template&id=79c0896a"
import script from "./AngsuranKelompok.vue?vue&type=script&lang=js"
export * from "./AngsuranKelompok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports